import { useState } from 'react'

import { useRouter } from 'next/router'

import { Hit } from 'algoliasearch/lite'

import { useAppFilters, useAppsCurrentcategories } from '../AppsProvider'

type AppResult = {
	hitsPerPage?: number
	nbHits?: number
	nbPages?: number
	hits?: Hit[]
	page?: number
	query?: string
	params?: string
}

export function useAppFeed() {
	const { query, isReady } = useRouter()
	const [searchUrl, setSearchUrl] = useState<string>()
	const [status, setStatus] = useState<string>()
	const [results, setResults] = useState<AppResult>({})
	const { appTypeFilter, compatibleWithFilter, costPlansFilter, ratingFilter, tierFilter } =
		useAppFilters()

	const { parentCategory, childCategory } = useAppsCurrentcategories()
	const categoriesLvl0 = parentCategory && !childCategory ? parentCategory.slug : null
	const categoriesLvl1 =
		parentCategory && childCategory ? `${parentCategory.slug}___${childCategory.slug}` : null

	const getAlgoliaMarketplaceApps = async (url: string) => {
		setStatus('loading')
		setSearchUrl(url)

		try {
			let algoliaMarketplaceApps
			const algoliaMarketplaceAppsRes = await fetch(url)
			algoliaMarketplaceApps = await algoliaMarketplaceAppsRes.json()

			const appResult = {
				__isArtificial: algoliaMarketplaceApps.__isArtificial,
				nbHits: algoliaMarketplaceApps.nbHits,
				hits: algoliaMarketplaceApps.hits
			}

			setResults(appResult as unknown as AppResult)
			setStatus('idle')
		} catch (e) {
			setResults({})
			setStatus('error')
		}
	}

	let url = `/api/algolia/marketplace/apps/apps-feed/?env=${process.env.NODE_ENV}`
	if (typeof query.query === 'string') url = `${url}&searchQuery=${query.query}`
	if (typeof query.page === 'string') url = `${url}&page=${query.page}`
	if (typeof query.sort === 'string') url = `${url}&sortFilter=${query.sort}`
	if (typeof tierFilter === 'string') url = `${url}&tierFilter=${tierFilter}`
	if (typeof ratingFilter === 'string') url = `${url}&ratingFilter=${ratingFilter}`
	if (typeof appTypeFilter === 'string') url = `${url}&appTypeFilter=${appTypeFilter}`
	if (typeof costPlansFilter === 'string') url = `${url}&costPlansFilter=${costPlansFilter}`
	if (typeof compatibleWithFilter === 'string')
		url = `${url}&compatibleWithFilter=${compatibleWithFilter}`
	if (typeof categoriesLvl0 === 'string') url = `${url}&categoriesLvl0=${categoriesLvl0}`
	if (typeof categoriesLvl1 === 'string') url = `${url}&categoriesLvl1=${categoriesLvl1}`

	if (isReady && (!status || searchUrl !== url)) {
		getAlgoliaMarketplaceApps(url)
	}

	return {
		status,
		results
	} as {
		status: 'loading' | 'stalled' | 'error' | 'idle'
		results?: { nbHits: number; __isArtificial: boolean; hits: Hit[] }
	}
}
